import { useEffect, useState } from "react";
import Select from "react-select";

import { useCustomerGroupDwQuery } from "../../../services/customerGroupApi";
import customStyles from "./SelectFeild";

const CustomergroupSelect = ({ handleSelectGroup, group, setValue }) => {
  const [customer, setCustomer] = useState([
    { value: "no-Group", label: "Select Group" },
  ]);
  const { data, isSuccess } = useCustomerGroupDwQuery();

  useEffect(() => {
    const dw = [{ value: "no-Group", label: "Select Group" }];
    if (isSuccess && Array.isArray(data) && data.length > 0) {
      const groupOptions = data.map((user) => ({
        value: user?._id,
        label: user?.name,
      }));
      setCustomer([...dw, ...groupOptions]);
    } else {
      setCustomer(dw);
    }
  }, [data, isSuccess]);

  const handleSelect = (selectedOption) => {
    const isNoGroup =
      !selectedOption ||
      selectedOption.value === "no-Group" ||
      !selectedOption.value;

    const selectedValue = isNoGroup ? null : selectedOption.value;

    if (setValue) {
      setValue("group", selectedValue, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }

    if (handleSelectGroup) {
      handleSelectGroup(isNoGroup ? null : selectedOption);
    }
  };

  const selectedValue =
    customer.find((option) => option.value === group) ||
    (!group ? customer[0] : null);

  return (
    <Select
      className="basic-single"
      classNamePrefix="select"
      isClearable={true}
      value={selectedValue}
      onChange={handleSelect}
      isSearchable={true}
      options={customer}
      styles={customStyles}
    />
  );
};

export default CustomergroupSelect;
